/* Axis-internal OR, axis-between AND. One instance per Shopify section. */
customElements.whenDefined('andcharlie-styling-feed').then(() => {
  if (customElements.get('andcharlie-styling-gallery')) return;
  const ranges = [
    [5, 6.5, '5.0–6.4kg'], [6.5, 7.5, '6.5–7.4kg'], [7.5, 8.5, '7.5–8.4kg'],
    [8.5, 9.5, '8.5–9.4kg'], [9.5, 12, '9.5–11.9kg'], [12, 13, '12.0–12.9kg'],
    [13, 17.1, '13.0–17.0kg'], [19, 22, '19–22kg未満'], [22, 25.1, '22–25kg'],
    [null, null, 'その他の体重']
  ];
  const axes = ['breed', 'weight', 'category', 'product'];
  const empty = () => Object.fromEntries(axes.map(axis => [axis, new Set()]));
  const clone = state => Object.fromEntries(axes.map(axis => [axis, new Set(state[axis])]));
  const list = value => { try { return JSON.parse(value || '[]'); } catch { return []; } };
  customElements.define('andcharlie-styling-gallery', class extends customElements.get('andcharlie-styling-feed') {
    afterLoad(signal) {
      this.dialog = this.querySelector('[data-ac-filter-dialog]');
      this.applied = empty();
      this.options = Object.fromEntries(axes.map(axis => [axis, new Map()]));
      this.cards = [...this.querySelector('[data-ac-grid]').children].map(element => ({
        element, weight: element.dataset.weight.trim() === '' ? NaN : Number(element.dataset.weight),
        breed: element.dataset.breed || '', products: list(element.dataset.products),
        titles: list(element.dataset.productTitles), categories: list(element.dataset.categories)
      }));
      this.querySelectorAll('[data-ac-generated]').forEach(el => el.remove());
      ranges.forEach((range, i) => this.options.weight.set(String(i), range[2]));
      this.cards.forEach(card => {
        if (card.breed) this.options.breed.set(card.breed, card.breed);
        card.products.forEach((handle, i) => this.options.product.set(handle, card.titles[i] || handle));
      });
      this.querySelectorAll('[data-axis="category"]').forEach(button => this.options.category.set(button.dataset.value, button.textContent.trim()));
      // Product names are retained only for existing product-page deep links.
      for (const axis of ['weight', 'breed']) {
        const options = [...this.options[axis]];
        if (axis !== 'weight') options.sort((a, b) => a[1].localeCompare(b[1], 'ja'));
        options.forEach(([value, label]) => this.querySelector(`[data-ac-options="${axis}"]`).append(this.makeButton(axis, value, label)));
      }
      const sidebar = this.querySelector('[data-ac-sidebar]');
      if (sidebar) {
        sidebar.replaceChildren();
        for (const [axis, label] of [['breed', '犬種'], ['weight', '体重'], ['category', 'カテゴリ']]) {
          if (!this.options[axis].size) continue;
          const heading = document.createElement('div');
          heading.className = 'ac-item-index-menu-headline'; heading.textContent = label;
          const group = document.createElement('div'); group.className = 'ac-item-index-menu-navi';
          group.setAttribute('role', 'group'); group.setAttribute('aria-label', label);
          this.options[axis].forEach((text, value) => {
            const button = this.makeButton(axis, value, text, true); group.append(button);
          });
          sidebar.append(heading, group);
        }
        sidebar.hidden = false;
      }
      this.querySelectorAll('[data-ac-axis-section]').forEach(el => {
        el.hidden = this.options[el.dataset.acAxisSection].size === 0;
      });
      // Restore product deep links in the same state machine as manual filtering.
      const params = new URLSearchParams(location.search);
      for (const axis of axes) params.getAll(axis).forEach(value => {
        if (this.options[axis].has(value) || axis === 'product') this.applied[axis].add(value);
      });
      this.draft = clone(this.applied);
      this.querySelectorAll('[data-ac-filter-open]').forEach(button => { button.hidden = false; });
      this.addEventListener('click', event => this.handleClick(event), { signal });
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.restoreScroll(); }, { signal });
      this.dialog.addEventListener('cancel', () => { this.draft = clone(this.applied); this.restoreScroll(); }, { signal });
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')].filter(element => element.getClientRects().length);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, { signal });
      window.addEventListener('popstate', () => {
        const query = new URLSearchParams(location.search); this.applied = empty();
        axes.forEach(axis => query.getAll(axis).forEach(value => {
          if (this.options[axis].has(value) || axis === 'product') this.applied[axis].add(value);
        }));
        this.render(false);
      }, { signal });
      this.render(false);
      this.dataset.acReady = 'true';
    }

    makeButton(axis, value, label, sidebar = false) {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.axis = axis; button.dataset.value = value;
      button.dataset.acGenerated = ''; button.setAttribute('aria-pressed', 'false');
      button.dataset.selected = 'false';
      button.className = sidebar ? 'ac-sidebar-option' : 'ac-filter__pill';
      if (sidebar) {
        button.dataset.acSidebarOption = '';
        const mark = document.createElement('span'); mark.className = 'ac-check'; mark.setAttribute('aria-hidden', 'true');
        const text = document.createElement('span'); text.className = 'ac-option-name'; text.textContent = label;
        button.append(mark, text);
      } else button.textContent = label;
      return button;
    }

    handleClick(event) {
      const button = event.target.closest('button');
      if (event.target === this.dialog) { this.closeDialog(); return; }
      if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-ac-filter-open')) {
        this.draft = clone(this.applied); this.syncButtons(this.draft);
        this.previousOverflow ??= document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
      } else if (button.hasAttribute('data-ac-filter-close')) this.closeDialog();
      else if (button.hasAttribute('data-ac-filter-apply')) {
        this.applied = clone(this.draft); this.render(); this.closeDialog();
      } else if (button.hasAttribute('data-ac-filter-clear')) {
        this.draft = empty(); this.syncButtons(this.draft);
      } else if (button.hasAttribute('data-ac-filter-reset')) {
        this.applied = empty(); this.render();
        this.focusFilterControl();
      } else if (button.hasAttribute('data-ac-remove-filter')) {
        this.applied[button.dataset.axis].delete(button.dataset.value); this.render();
        this.focusFilterControl();
      } else if (button.dataset.axis && button.dataset.value) {
        const sidebar = button.hasAttribute('data-ac-sidebar-option');
        const state = sidebar ? this.applied : this.draft;
        const values = state[button.dataset.axis];
        if (values.has(button.dataset.value)) values.delete(button.dataset.value);
        else values.add(button.dataset.value);
        if (sidebar) this.render(); else this.syncButtons(this.draft);
      }
    }

    focusFilterControl() {
      const control = [...this.querySelectorAll('[data-ac-filter-open], [data-ac-sidebar-option]')].find(element => element.getClientRects().length);
      control?.focus();
    }

    closeDialog() {
      this.dialog.close();
      this.restoreScroll();
    }

    restoreScroll() {
      if (this.previousOverflow !== undefined) {
        document.body.style.overflow = this.previousOverflow;
        this.previousOverflow = undefined;
      }
    }

    disconnectedCallback() {
      this.dialog?.close(); this.restoreScroll(); super.disconnectedCallback();
    }

    syncButtons(state) {
      this.querySelectorAll('button[data-axis]:not([data-ac-remove-filter])').forEach(button => {
        const values = button.hasAttribute('data-ac-sidebar-option') ? this.applied : state;
        const selected = values[button.dataset.axis].has(button.dataset.value);
        button.dataset.selected = String(selected); button.setAttribute('aria-pressed', String(selected));
      });
      const count = this.cards.filter(card => this.matches(card, state)).length;
      this.querySelector('[data-ac-filter-apply]').textContent = `${count}件のスタイリングを見る`;
    }

    matches(card, state = this.applied) {
      if (state.weight.size) {
        if (!Number.isFinite(card.weight)) return false;
        const inRange = range => card.weight >= range[0] && card.weight < range[1];
        if (![...state.weight].some(value => Number(value) === ranges.length - 1
          ? !ranges.slice(0, -1).some(inRange) : inRange(ranges[Number(value)]))) return false;
      }
      return (!state.category.size || card.categories.some(value => state.category.has(value))) &&
        (!state.product.size || card.products.some(value => state.product.has(value))) &&
        (!state.breed.size || state.breed.has(card.breed));
    }

    render(updateUrl = true) {
      let visible = 0;
      this.cards.forEach(card => { card.element.hidden = !this.matches(card); if (!card.element.hidden) visible++; });
      this.querySelector('[data-ac-count]').textContent = `${visible} POSTS`;
      this.querySelector('[data-ac-empty]').hidden = visible !== 0;
      const active = this.querySelector('[data-ac-active-filters]'); active.replaceChildren();
      axes.forEach(axis => this.applied[axis].forEach(value => {
        const tag = document.createElement('button'); tag.type = 'button';
        tag.className = 'ac-gallery__active-tag'; tag.dataset.acRemoveFilter = '';
        tag.dataset.axis = axis; tag.dataset.value = value;
        const label = this.options[axis].get(value) || value;
        tag.textContent = `${label} ×`; tag.setAttribute('aria-label', `${label}の絞り込みを解除`); active.append(tag);
      }));
      const selectedCount = active.children.length;
      if (selectedCount) {
        const reset = document.createElement('button'); reset.type = 'button';
        reset.className = 'ac-gallery__reset'; reset.dataset.acFilterReset = '';
        reset.textContent = 'すべて解除'; active.append(reset);
      }
      active.dataset.hasFilters = String(!!selectedCount);
      this.querySelectorAll('[data-ac-filter-open]').forEach(button => {
        button.classList.toggle('ac-filter-btn--has-filter', !!selectedCount);
        button.setAttribute('aria-label', selectedCount ? `条件を選んで検索（${selectedCount}件の条件を選択中）` : '条件を選んで検索');
      });
      this.querySelectorAll('[data-ac-filter-count]').forEach(badge => {
        badge.textContent = String(selectedCount); badge.hidden = !selectedCount;
      });
      this.draft = clone(this.applied); this.syncButtons(this.applied);
      if (updateUrl) {
        const url = new URL(location.href);
        axes.forEach(axis => { url.searchParams.delete(axis); this.applied[axis].forEach(value => url.searchParams.append(axis, value)); });
        history.replaceState(history.state, '', url);
      }
    }
  });
});
